import { useAdminApi as a } from "../../components/providers/AdminApiProvider/AdminApiProvider.js";
import { useAdminStore as c } from "../../store/adminStore.js";
import { useEffect as d, useRef as m, useState as o } from "react";
function R() {
  const { server: r } = a(), e = c((s) => s.user.sessionReady), [i, n] = o(!e), [f, u] = o(null), t = m(!1);
  return d(() => {
    e || t.current || (t.current = !0, r.refreshSelf().then(() => {
      n(!1);
    }).catch((s) => {
      u(s instanceof Error ? s : new Error(String(s))), n(!1);
    }));
  }, [e, r]), {
    isLoading: e ? !1 : i,
    isReady: e,
    error: f
  };
}
export {
  R as useAdminSessionInit
};

//# sourceMappingURL=useAdminSessionInit.js.map